import { CartSettings, InjectedCartProps, withCart as withCartFactory } from '@grandvisionhq/next'

import { deliveryResolverFactory } from '../../util/delivery-resolver-factory'

export const settings: CartSettings = {
  deliveryResolverFactory,
  allowBackOrder: true,
  isDiscountCodeEnabled: true,
  maximumQuantity: 10,
  showCartDiscountOnLineItem: true,
  showShippingMethod: true,
  showSubTotal: true,
  showTotalDiscount: true,
}

export type { InjectedCartProps }

export const withCart = withCartFactory(settings)
